import store from '../../services/data'
import order from '../../services/order'
export default {
    actions: {
        async fetchUser(ctx, order) {
            let get_user_url = '/api/get-user-info';

            if(order && order.send_order) ctx.state.send_order = true;
            else ctx.state.send_order = false;

            if(localStorage.getItem('token') ) {
                axios
                    .post(get_user_url, {}, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('token')
                        }
                    })
                    .then(response => {
                        if (response.status == 200) {
                            ctx.commit('setUser', response.data);
                        } else {
                            localStorage.removeItem('token');
                            console.log('User is not authenticated');
                            ctx.commit('setUser', null);
                        }
                    })
                    .catch(error => {
                        if(error) {
                            localStorage.removeItem('token');
                            // window.location.href = '/'
                        }
                    })
            }
        },
    },

    mutations: {
        setUser(state, user) {
            // if(user.discount_program && user.discount_program.discount_program) store.common_price.discount = user.discount_program.discount_program;
            // else store.common_price.discount = 0;
            if(user.discount_program && user.discount_program.discount_program) {
                order.state.discount_personal = user.discount_program.discount_program;
                if(user.discount_program.discount_program > order.state.discount_period) store.common_price.discount = user.discount_program.discount_program;
            }
            else order.state.discount_personal = 0;
            state.user = user;

            if(state.send_order) order.sendOrder('set_discount');
        },

    },

    state: {
        user: null,
        send_order: false
    },

    getters: {
        getUser(state) {
            return state.user
        }
    },
}
